<app-pcbread-crumb [data]="'Reports,ReportCalender'"></app-pcbread-crumb>

<div class="card animate__animated animate__backInDown">
  <div class="row px-4 py-2">
    <div class="p-1 ps-2 col-11">
      <div class="row">
        <div class="col-3 p-0 px-3">
          <div class="input-group">
            <label class="input-group-text" for="inputGroupSelect01">
              {{ "ReportType" | translate }}
            </label>
            <select
              class="form-select"
              [ngClass]="{
                'is-invalid': backEndRequest.reportTypeMessage != null
              }"
              [(ngModel)]="backEndRequest.reportType"
            >
              <option value="-1">
                {{ "select item" | translate }}
              </option>
              <option *ngFor="let type of reportType" [value]="type.value">
                {{ type.name | translate }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-6 pe-4">
          <form [formGroup]="drugSearchForm">
            <div class="input-group">
              <button
                type="button"
                class="btn btn-outline-primary px-2"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                [hidden]="!searchWithDrug"
              >
                {{ "ProductBrandName" | translate }}
                <i class="fas fa-angle-down ms-3"></i>
              </button>
              <button
                type="button"
                class="btn btn-outline-primary px-2 is-first-item"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                [hidden]="searchWithDrug"
              >
                {{ "drugGroupName" | translate }}
                <i class="fas fa-angle-down ms-3"></i>
              </button>

              <ul class="dropdown-menu">
                <li>
                  <button class="dropdown-item" (click)="searchWithDrug = true">
                    {{ "ProductBrandName" | translate }}
                  </button>
                </li>
                <li>
                  <button
                    class="dropdown-item"
                    (click)="searchWithDrug = false"
                  >
                    {{ "drugGroupName" | translate }}
                  </button>
                </li>
              </ul>
              <input
                [hidden]="!searchWithDrug"
                id="drugBrandName"
                type="text"
                autocomplete="off"
                appSelectOnFocus
                formControlName="drugBrandName"
                class="form-control Focusable iner-Focusable search-input-box not-last"
                placeholder="{{ 'SearchAndScanBarcode' | translate }}"
                [ngClass]="{
                  'is-invalid':
                    backEndRequest.drugNameMessage != '' &&
                    backEndRequest.drugNameMessage != null
                }"
                [(ngModel)]="backEndRequest.drugName"
                (keyup.escape)="modalIsOpen = false"
              />
              <app-search-box
                [data]="searchData"
                [addButton]="false"
                [right]="'-80%'"
                [leftTriangle]="'85%'"
                [fields]="searchFields"
                [urlName]="'ReportCalender_DrugSearchBoxTable'"
                [paging]="searchPaging"
                [modalIsOpen]="modalIsOpen"
                (parentAction)="parentSearchAction($event)"
              ></app-search-box>

              <select
                [hidden]="searchWithDrug"
                class="form-select"
                [ngClass]="{
                  'is-invalid': backEndRequest.drugGroupNameMessage != null
                }"
                [(ngModel)]="backEndRequest.drugGroupId"
              >
                <option value="-1">
                  {{ "select item" | translate }}
                </option>
                <option
                  *ngFor="let drugGroup of drugGroups"
                  [value]="drugGroup.id"
                >
                  {{ drugGroup.value }}
                </option>
              </select>
            </div>
          </form>
        </div>

        <div class="col-3 pe-4">
          <button
            type="button"
            class="btn btn-outline-primary top-search-button"
            (click)="searchNewItem()"
          >
            {{ "search" | translate }}
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-xl-3 col-lg-2 col-md-2 col-sm-2 col-xs-3">
          <ng-container *ngIf="backEndRequest.reportType == 3">
            <div class="edit-form">
              <div class="validation-alert-sale-buy">
                <p>{{ backEndRequest.insuranceMessage }}</p>
              </div>
              <label class="form-label" for="drugGroupNameMessage">
                {{ "insurance" | translate }}
              </label>

              <select
                class="form-select"
                [ngClass]="{
                  'is-invalid': backEndRequest.insuranceMessage != null
                }"
                [(ngModel)]="backEndRequest.insuranceId"
              >
                <option value="-1">
                  {{ "select item" | translate }}
                </option>
                <option
                  *ngFor="let insurance of insurances"
                  [value]="insurance.id"
                >
                  {{ insurance.value }}
                </option>
              </select>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end align-items-start p-1 col-1">
      <button
        type="button"
        class="btn btn-icon btn-outline-primary ms-1"
        placement="bottom"
        [routerLink]="['/Sale']"
        ngbTooltip="{{ 'Prescription' | translate }}"
      >
        <span class="fas fa-prescription-bottle-alt"></span>
      </button>
      <button
        type="button"
        class="btn btn-icon btn-outline-primary ms-1"
        placement="bottom"
        [routerLink]="['/SaleList']"
        ngbTooltip="{{ 'List' | translate }}"
      >
        <span class="tf-icons bx bx-list-check"></span>
      </button>
    </div>

    <div class="col-1 col-lg-1 col-xl-1 col-xxl-1 ps-2 pe-1 py-2 weekly-report">
      <div class="side-box week-sum position-relative">
        <div class="month-week-header">
          {{ "sum" | translate }}
        </div>
        <ng-container *ngFor="let week of weeks">
          <div
            class="month-week-body"
            [ngClass]="{ 'not-active-day': !week.isActive }"
          >
            <ng-container *ngIf="week.isActive">
              <span class="week-number ms-2">
                {{ week.weekNumber }}
              </span>
              <span
                class="week-number pe-2"
                [ngClass]="fistClass"
                *ngIf="week.input != undefined && week.input != 0"
              >
                {{ week.input | dataType : "" }}
                <i class="ms-2" [ngClass]="firstIcon"></i>
              </span>
              <span
                class="week-number pe-2"
                [ngClass]="secondClass"
                *ngIf="week.output != undefined && week.output != 0"
              >
                {{ week.output | dataType : "" }}
                <i class="ms-2" [ngClass]="secondIcon"></i>
              </span>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
    <div
      class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 col-xxl-8 px-1 py-2 calender-report"
    >
      <div class="calender-box position-relative">
        <div class="calender-body">
          <div class="calender-day calender-header p-1">
            <span class="day-number">
              {{ "Saturday" | translate }}
            </span>
          </div>
          <div class="calender-day calender-header p-1">
            <span class="day-number">
              {{ "Sunday" | translate }}
            </span>
          </div>
          <div class="calender-day calender-header p-1">
            <span class="day-number">
              {{ "Monday" | translate }}
            </span>
          </div>
          <div class="calender-day calender-header p-1">
            <span class="day-number">
              {{ "Tuesday" | translate }}
            </span>
          </div>
          <div class="calender-day calender-header p-1">
            <span class="day-number">
              {{ "Wednesday" | translate }}
            </span>
          </div>
          <div class="calender-day calender-header p-1">
            <span class="day-number">
              {{ "Thursday" | translate }}
            </span>
          </div>
          <div class="calender-day calender-header p-1">
            <span class="day-number">
              {{ "Friday" | translate }}
            </span>
          </div>
          <ng-container *ngFor="let day of thisMonth.days; let i = index">
            <div
              class="calender-day p-1"
              [ngClass]="{
                'not-active-day': day.dayOfMonth == 0,
                holiday: day.isHoliday
              }"
            >
              <ng-container *ngIf="day.dayOfMonth != 0">
                <span class="day-number">
                  {{ day.dayOfMonth }}
                </span>
                <span
                  class="day-number day-number-sale pe-2"
                  [ngClass]="fistClass"
                  *ngIf="day.inputValue != undefined && day.inputValue != 0"
                >
                  {{ day.inputValue | dataType : "" }}
                  <i class="ms-2" [ngClass]="firstIcon"></i>
                </span>
                <span
                  class="day-number day-number-buy pe-2"
                  [ngClass]="secondClass"
                  *ngIf="day.outputValue != undefined && day.outputValue != 0"
                >
                  {{ day.outputValue | dataType : "" }}
                  <i class="ms-2" [ngClass]="secondIcon"></i>
                </span>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div
      class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3 pe-2 ps-1 py-2 monthly-report"
    >
      <div class="side-box position-relative">
        <div class="row px-4 pt-2">
          <div class="col-3 p-0">
            <span
              class="year-report year-report-sale me-2"
              *ngIf="outputYear != undefined && outputYear != 0"
              [ngClass]="fistClass"
            >
              {{ outputYear | dataType : "" }}
              <i class="ms-2" [ngClass]="firstIcon"></i>
            </span>
          </div>
          <div class="col-3 p-0">
            <span
              class="year-report year-report-buy me-2"
              [ngClass]="secondClass"
              *ngIf="inputYear != undefined && inputYear != 0"
            >
              {{ inputYear | dataType : "" }}
              <i class="ms-2" [ngClass]="secondIcon"></i>
            </span>
          </div>
          <div class="col-3 p-0">
            <input type="number" class="form-control" [(ngModel)]="year" />
          </div>
          <div class="col-3 p-0 ps-1">
            <button
              type="button"
              class="btn btn-outline-primary month-search-button"
            >
              {{ "Search" | translate }}
            </button>
          </div>
        </div>
        <hr />
        <div class="months-box p-1 pt-2">
          <ng-container *ngFor="let item of months; let i = index">
            <div class="mt-2" [ngClass]="item.monthCssClass">
              <button
                class="year-month month-button"
                (click)="chooseMonth(i + 1)"
                [ngClass]="{
                  active: item.monthNumber == thisMonth.monthNumber
                }"
              >
                <span class="month-name mb-2">
                  {{ item.monthName }}
                </span>
                <span
                  class="month-name"
                  *ngIf="item.inputValue != undefined"
                  [ngClass]="fistClass"
                >
                  {{ item.inputValue | dataType : "" }}
                  <i class="ms-2" [ngClass]="firstIcon"></i>
                </span>
                <span
                  class="month-name report-item"
                  *ngIf="item.outputValue != undefined"
                  [ngClass]="secondClass"
                >
                  {{ item.outputValue | dataType : "" }}
                  <i class="ms-2" [ngClass]="secondIcon"></i>
                </span>
              </button>
            </div>
          </ng-container>
        </div>
        <hr />
        <div class="final-report"></div>
      </div>
    </div>
  </div>
  <app-loading-panel *ngIf="loading"></app-loading-panel>
</div>
